// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_match_backfill".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "stock_match_backfill" table (1:1 with a DB row, on the wire). */
export const stockMatchBackfillAtomSchema = z.object({
    version: z.string(),
    servicesMatched: z.number(),
    completedAt: z.string().datetime(),
});
//# sourceMappingURL=stockMatchBackfill.js.map